<template>
  <div class="relative bg-white">
    <nav
      class="hidden xl:flex justify-between items-center gap-4 px-[120px] 2xl:px-32 py-6 mb-10"
    >
      <div class="flex items-center">
        <img
          src="@/assets/images/Logo.png"
          width="45"
          height="45"
          alt="logo"
          class="mr-[24px]"
        />
        <ul class="flex items-center" v-click-outside="closeMenu">
          <li
            v-for="link of links"
            class="text-nowrap PC_Body1-R px-[8px] py-[10px]"
            :key="link.link"
          >
            <RouterLink
              v-if="!link.childRoutes"
              activeClass="text-primary"
              class="text-[16px] hover:text-primary"
              :data-text="link.text"
              :to="link.link"
              @click="
                closeAllMenus();
                activeMenu = link.id;
              "
            >
              <!-- inline-block  -->
              <span class="min-w-[100px] text-center">{{ link.text }}</span>
            </RouterLink>
            <div v-else class="relative cursor-pointer">
              <div
                @click="expandMenu(link.id)"
                class="flex items-center hover:text-primary"
                :class="activeMenu == link.id ? 'text-primary' : ''"
                :id="link.id"
              >
                <span class="text-[16px]">{{ link.text }}</span>
                <CaretDownIcon class="caret-icon ml-2.5 duration-300 w-6 h-6" />
              </div>
              <div
                v-if="activeMenu === link.id && menuOpen === true"
                class="absolute w-full top-10 left-0 bg-white rounded-lg mt-2 z-10"
              >
                <ul
                  class="flex flex-col w-full border border-grey-light rounded-[6px] overflow-hidden"
                >
                  <li v-for="child of link.childRoutes" :key="child.link">
                    <RouterLink
                      class="block px-4 py-2 hover:bg-soft-pink hover:text-primary"
                      :to="child.link"
                      @click="menuOpen = false"
                    >
                      {{ child.text }}
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="flex items-stretch gap-2.5">
        <ManualDropdown />
        <RouterLink
          class="flex justify-center items-center gap-1 text-white font-light w-[114px] min-h-[50px] px-4 rounded-[6px] duration-100 !text-[14px] bg-primary text-nowrap hover:bg-primary/50"
          to="/login"
        >
          <UserIcon class="text-white w-6 h-6" />
          <span class="text-nowrap font-normal">เข้าสู่ระบบ</span>
        </RouterLink>
      </div>
    </nav>
    <nav class="flex justify-between items-center xl:hidden px-4 py-5">
      <div class="flex items-center gap-1.5">
        <img src="@/assets/images/logo.png" class="w-[35px] h-[35px]" />
        <div>
          <p class="text-[8px] md:text-sm text-primary font-semibold">
            ระบบภูมิสารสนเทศทางสาธารณสุข<br />สำหรับศูนย์ปฏิบัติการภาวะฉุกเฉิน
            (จีโอเฮลท์ ศปฉ.)
          </p>
        </div>
      </div>
      <button class="btn-secondary px-2.5" @click="mobileMenuIsOpened = true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M3.33333 5.00002C3.33333 4.77901 3.42113 4.56705 3.57741 4.41076C3.73369 4.25448 3.94565 4.16669 4.16666 4.16669H15.8333C16.0543 4.16669 16.2663 4.25448 16.4226 4.41076C16.5789 4.56705 16.6667 4.77901 16.6667 5.00002C16.6667 5.22103 16.5789 5.433 16.4226 5.58928C16.2663 5.74556 16.0543 5.83335 15.8333 5.83335H4.16666C3.94565 5.83335 3.73369 5.74556 3.57741 5.58928C3.42113 5.433 3.33333 5.22103 3.33333 5.00002ZM3.33333 10C3.33333 9.77901 3.42113 9.56705 3.57741 9.41076C3.73369 9.25448 3.94565 9.16669 4.16666 9.16669H15.8333C16.0543 9.16669 16.2663 9.25448 16.4226 9.41076C16.5789 9.56705 16.6667 9.77901 16.6667 10C16.6667 10.221 16.5789 10.433 16.4226 10.5893C16.2663 10.7456 16.0543 10.8334 15.8333 10.8334H4.16666C3.94565 10.8334 3.73369 10.7456 3.57741 10.5893C3.42113 10.433 3.33333 10.221 3.33333 10ZM4.16666 14.1667C3.94565 14.1667 3.73369 14.2545 3.57741 14.4108C3.42113 14.567 3.33333 14.779 3.33333 15C3.33333 15.221 3.42113 15.433 3.57741 15.5893C3.73369 15.7456 3.94565 15.8334 4.16666 15.8334H15.8333C16.0543 15.8334 16.2663 15.7456 16.4226 15.5893C16.5789 15.433 16.6667 15.221 16.6667 15C16.6667 14.779 16.5789 14.567 16.4226 14.4108C16.2663 14.2545 16.0543 14.1667 15.8333 14.1667H4.16666Z"
            fill="#9B237B"
          />
        </svg>
      </button>

      <!-- Backdrop overlay for mobile menu -->
      <div
        v-if="mobileMenuIsOpened"
        class="fixed inset-0 bg-black/20 z-40"
        @click="mobileMenuIsOpened = false"
      ></div>

      <!-- Mobile sidebar menu -->
      <aside
        class="fixed top-0 right-0 w-full sm:w-[350px] bg-white h-screen transition-all duration-300 ease-in-out shadow-2xl z-50 p-4"
        :class="
          mobileMenuIsOpened
            ? 'translate-x-0 sm:right-0'
            : 'translate-x-full sm:-right-[350px]'
        "
      >
        <div class="flex justify-between items-center">
          <div class="flex items-center gap-2">
            <img src="@/assets/images/logo.png" class="w-[35px] h-[35px]" />
            <p
              class="text-[8px] font-semibold text-primary font-[IBM_Plex_Sans_Thai]"
            >
              ระบบภูมิสารสนเทศทางสาธารณสุข <br />
              สำหรับศูนย์ปฏิบัติการภาวะฉุกเฉิน (จีโอเฮลท์ ศปฉ.)
            </p>
          </div>

          <button
            class="btn-secondary block px-2.5 cursor-pointer"
            @click="mobileMenuIsOpened = false"
          >
            <CloseIcon class="w-5 h-5" />
          </button>
        </div>
        <div id="scrollBar" class="text-md overflow-y-auto">
          <ul class="">
            <li v-for="menu in links" :key="menu.text" class="rounded-md">
              <RouterLink
                v-if="!menu.childRoutes"
                :to="menu.link"
                activeClass="!text-primary bg-white !stroke-primary !fill-primary"
                @click="onMenuClick(menu)"
                class="flex items-center gap-2.5 h-12 rounded-md my-2 pl-[10px] text-primary-dark"
              >
                <component :is="menu.icon" class="!fill-primary w-[22px]" />
                <span class="PC_Body2-R">{{ menu.text }}</span>
              </RouterLink>

              <div v-else>
                <div
                  :ref="'parent ' + menu.text"
                  class="parent flex items-center pl-[10px] gap-2.5 h-12 rounded-sm mt-2 text-primary-dark cursor-pointer"
                  @click="toggleMenu(menu.text)"
                >
                  <component :is="menu.icon" class="!fill-primary w-[22px]" />
                  <span class="PC_Body2-R">{{ menu.text }}</span>
                  <CaretDownIcon
                    class="caret-icon ml-auto mr-2.5 duration-300 w-6 h-6"
                  />
                </div>
                <ul
                  :ref="'child ' + menu.text"
                  class="child hidden w-full bg-soft-pink rounded-b-md"
                >
                  <li
                    v-for="childRoute in menu.childRoutes"
                    :key="
                      childRoute.link || childRoute.route || childRoute.text
                    "
                  >
                    <RouterLink
                      @click="mobileMenuIsOpened = false"
                      :to="childRoute.link"
                      activeClass=""
                      class="flex items-center gap-2.5 h-12 mb-2 pl-[10px] text-primary-dark"
                    >
                      <span class="PC_Body2-R">{{ childRoute.text }}</span>
                    </RouterLink>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <hr class="my-2.5" />
          <div>
            <ul class="text-sm font-normal space-y-2.5">
              <li class="flex items-center gap-2.5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M9.99998 13.3333L5.83331 9.16665L6.99998 7.95831L9.16665 10.125V3.33331H10.8333V10.125L13 7.95831L14.1666 9.16665L9.99998 13.3333ZM4.99998 16.6666C4.54165 16.6666 4.14942 16.5036 3.82331 16.1775C3.4972 15.8514 3.33387 15.4589 3.33331 15V12.5H4.99998V15H15V12.5H16.6666V15C16.6666 15.4583 16.5036 15.8508 16.1775 16.1775C15.8514 16.5041 15.4589 16.6672 15 16.6666H4.99998Z"
                    fill="#9B237B"
                  />
                </svg>
                <span class="flex-1">คู่มือการใช้งาน</span>
              </li>
              <li class="">
                <a
                  class="group py-3 px-2.5 block text-[#1F1D1F] hover:bg-[#FBEFF8] cursor-pointer"
                  :href="PDFS.officer"
                  rel="noopener"
                  role="menuitem"
                  @click.stop="deferClose"
                >
                  <span>คู่มือเจ้าหน้าที่</span>
                </a>
              </li>
              <li class="">
                <a
                  class="group py-3 px-2.5 block text-[#1F1D1F] hover:bg-[#FBEFF8] cursor-pointer"
                  :href="PDFS.citizen"
                  rel="noopener"
                  role="menuitem"
                  @click.stop="deferClose"
                >
                  <span>คู่มือประชาชน</span>
                </a>
              </li>
            </ul>
            <hr class="my-2.5" />
          </div>
          <div class="p-5">
            <RouterLink
              class="w-full mt-auto flex justify-center items-center gap-1 text-white font-light min-h-[50px] px-4 rounded-[6px] duration-100 !text-[14px] bg-primary text-nowrap hover:bg-primary/50"
              to="/login"
              @click="mobileMenuIsOpened = false"
            >
              <UserIcon class="text-white w-6 h-6" />
              <span class="text-nowrap font-normal">เข้าสู่ระบบ</span>
            </RouterLink>
          </div>
        </div>
      </aside>
    </nav>
    <StatusModal ref="StatusModalRef" />
  </div>
</template>

<script setup>
import { onMounted, ref, getCurrentInstance, computed } from "vue";
import { RouterLink, useRouter, useRoute } from "vue-router";
import UserIcon from "@/assets/icons/user.icon.vue";
import StatusModal from "@/components/modals/StatusModal.vue";
import CaretDownIcon from "@/assets/icons/caretDown.icon.vue";
import DownloadIcon from "@/assets/icons/download.icon.vue";

// const router = useRouter();
// const route = useRoute();
// const ProfileModalRef = ref(null);
const StatusModalRef = ref(null);
const mobileMenuIsOpened = ref(false);

const links = ref([
  {
    id: "homePage",
    link: "/home-page",
    text: "หน้าแรก",
  },
  {
    text: "อุทกภัย และดินถล่ม",
    id: "floodsAndLandslide",
    childRoutes: [
      { link: "/floods", text: "อุทกภัย" },
      { link: "/landslide", text: "ดินถล่ม" },
    ],
  },
  {
    text: "ไฟป่า และหมอกควัน",
    id: "wildfireAndAirPollution",
    childRoutes: [
      { link: "/wildfire", text: "ไฟป่า" },
      { link: "/air-pollution", text: "หมอกควัน" },
    ],
  },
  {
    id: "earthquake",
    link: "/earthquake",
    text: "แผ่นดินไหว",
  },
  {
    id: "summerStorm",
    link: "/summer-storm",
    text: "พายุฤดูร้อน",
  },
  {
    id: "fire",
    link: "/fire",
    text: "อัคคีภัย",
  },
  {
    id: "epidemic",
    link: "/epidemic",
    text: "โรคระบาด",
  },
]);
const activeMenu = ref(null); 
const menuOpen = ref(false);
const { proxy } = getCurrentInstance();
const PDFS = {
  officer:
    "https://disaster-backend.gentechsoft.tech/api/download-user-doc/user",
  citizen:
    "https://disaster-backend.gentechsoft.tech/api/download-user-doc/pupulation", // ตรวจสะกดด้วย
};

function toggleMenu(tabName) {
  const parentEl = proxy.$refs["parent " + tabName];
  const childEl = proxy.$refs["child " + tabName];

  if (!parentEl || !parentEl[0] || !childEl || !childEl[0]) {
    console.warn(`Elements not found for ${tabName}`);
    return;
  }

  if (activeMenu.value !== tabName) {
    // Close previously active menu first
    if (activeMenu.value) {
      closeAllMenus();
    }

    // Open new menu
    parentEl[0].classList.add("!text-primary", "!px-4", "rounded-b-none");
    parentEl[0].children[1]?.classList.add("rotate-180"); // CaretDownIcon is at index 2
    childEl[0].classList.remove("hidden");
    activeMenu.value = tabName;
  } else {
    // Close current menu
    parentEl[0].classList.remove("!text-primary", "!px-4", "rounded-b-none");
    parentEl[0].children[1]?.classList.remove("rotate-180");
    childEl[0].classList.add("hidden");
    activeMenu.value = null;
  }
}

function onMenuClick(menu) {
  // Close any open dropdown menus
  closeAllMenus();
  // Close mobile menu
  mobileMenuIsOpened.value = false;
}

// Helper function to close all open menus
function closeAllMenus() {
  if (activeMenu.value) {
    // Close desktop dropdown
    menuOpen.value = false;

    // Find if current active menu has child routes and close mobile menu
    const currentMenuData = links.value.find(
      (link) => link.id === activeMenu.value || link.text === activeMenu.value
    );

    if (currentMenuData && currentMenuData.childRoutes) {
      const parentEl = proxy.$refs["parent " + currentMenuData.text];
      const childEl = proxy.$refs["child " + currentMenuData.text];

      if (parentEl && parentEl[0] && childEl && childEl[0]) {
        parentEl[0].classList.remove("bg-primary", "rounded-b-none");
        parentEl[0].children[2]?.classList.remove("rotate-180");
        childEl[0].classList.add("hidden");
      }
    }
  }

  activeMenu.value = null;
}

onMounted(() => {});

const closeMenu = () => {
  menuOpen.value = false;
};

const expandMenu = (menu) => {
  // If clicking the same menu that's already open, close it
  if (activeMenu.value === menu && menuOpen.value === true) {
    menuOpen.value = false;
    activeMenu.value = null;
  } else {
    // Close any open mobile menus first
    closeAllMenus();
    // Then open the new desktop dropdown
    activeMenu.value = menu;
    menuOpen.value = true;
  }
};
</script>
<style scoped lang="scss"></style>

<style>
.formBg {
  background-color: var(--color-formBg), rgba(255, 255, 255, 0.8);
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
}
</style>
